import React, {Component} from 'react';
import {observer, Provider, inject } from "mobx-react";
import commentsStore from "../../stores/commentsStore";
import Comments from "./Comments";
import historyVars from "../../utils/historyVars";
import LastComments from "./LastComments";


class CommentsWithStore extends Component {
  constructor(props) {
    super(props);
    this._commentsStore=new commentsStore(null, { comment_url_var: props.comment_url_var });
    if(this.props.standalone) {
      this._commentsStore.standalone = true;
    }
    if(this.props.editor_css) {
      this._commentsStore.editor_css = this.props.editor_css;
    }
    if(this.props.lang) {
      this.props.translateStore.lang=this.props.lang;
    }
    /*this._commentsStore.setRootElement(this.props.category, this.props.element);
    if(this.props.topic_starter) {
      this._commentsStore.setTopicStarter(this.props.topic_starter);
    }*/
    /*this._commentsStore.loadComments(true).then(()=>{
      this._commentsStore.moveToSelectedComment();
    });*/
  }

  componentWillUnmount() {
    this._commentsStore.destruct();
    historyVars.appendVars({ [this.props.comment_url_var || 'comment']:"" });
  }
  componentDidMount() {
    if(!this.props.meStore.me.inited) {
      if(this.props.translateStore.lang == "ru") {
        this.props.translateStore.fetchTranslate();
      }
      this.props.meStore.fetchMe();
    }
  }

  render() {
    if(!this.props.meStore.me.inited || !this.props.translateStore.translate.inited) {
      return null;
    }
    return (
      <div>
        <Provider commentsStore={this._commentsStore}>
          <div className={`${this.props.disable_wrapper?'':'hpadd20'}`}>
            <LastComments {...this.props} />
          </div>
        </Provider>
      </div>
    )
  }
}

export default inject("meStore","translateStore")(observer(CommentsWithStore));